import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import {
  Shield, AlertTriangle, Eye, Network, Download
} from 'lucide-react';

const getThreatColor = (type) => {
  switch (type) {
    case 'CRITICAL': return 'text-red-600 bg-red-100';
    case 'HIGH': return 'text-orange-600 bg-orange-100';
    case 'MEDIUM': return 'text-yellow-600 bg-yellow-100';
    case 'LOW': return 'text-blue-600 bg-blue-100';
    default: return 'text-gray-600 bg-gray-100';
  }
};

const OverviewTab = ({ threats, devices, setActiveTab }) => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Security Score</p>
              <p className="text-3xl font-bold text-green-600">92%</p>
            </div>
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
              <Shield className="w-6 h-6 text-green-600" />
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Active Threats</p>
              <p className="text-3xl font-bold text-red-600">{threats.filter(t => t.status === 'active').length}</p>
            </div>
            <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-red-600" />
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Protected Devices</p>
              <p className="text-3xl font-bold text-blue-600">{devices.length}</p>
            </div>
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
              <Network className="w-6 h-6 text-blue-600" />
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Detection Rate</p>
              <p className="text-3xl font-bold text-purple-600">99.8%</p>
            </div>
            <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center">
              <Eye className="w-6 h-6 text-purple-600" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>

    <Card>
      <CardHeader>
        <CardTitle>Quick Actions</CardTitle>
        <CardDescription>Common security management tasks</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <Button onClick={() => setActiveTab('agents')} className="h-20 flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-blue-500 to-blue-600">
            <Download className="w-6 h-6" /><span>Download Agent</span>
          </Button>
          <Button onClick={() => setActiveTab('threats')} className="h-20 flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-red-500 to-red-600">
            <AlertTriangle className="w-6 h-6" /><span>View Threats</span>
          </Button>
          <Button onClick={() => setActiveTab('devices')} className="h-20 flex flex-col items-center justify-center gap-2 bg-gradient-to-r from-purple-500 to-purple-600">
            <Network className="w-6 h-6" /><span>Manage Devices</span>
          </Button>
        </div>
      </CardContent>
    </Card>

    <Card>
      <CardHeader><CardTitle>Recent Threats</CardTitle></CardHeader>
      <CardContent>
        <div className="space-y-4">
          {threats.slice(0, 4).map((threat) => (
            <div key={threat.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
              <div className="flex items-center gap-3">
                <Badge className={getThreatColor(threat.type)}>{threat.type}</Badge>
                <div>
                  <p className="font-medium">{threat.title}</p>
                  <p className="text-sm text-gray-600">{threat.device} - {threat.timestamp}</p>
                </div>
              </div>
              <Badge variant="outline" className="capitalize">{threat.status}</Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  </div>
);

export default OverviewTab;
